// Generic api helpers

import axios from 'axios'
import * as d3 from 'd3-dsv'

import { devOnlyLog } from '@/utils/log'

/**
 * Helper method to get data from a TSV/CSV file
 *
 * @param {string} url - location to get data from
 * @returns {Object} - parsed data, converted from TSV/CSV to JSON
 */
async function getDsvData (url) {
  let parser
  const ext = url.split('.').pop().toLowerCase()
  switch (ext) {
    case 'tsv':
      parser = d3.tsvParse
      break
    case 'csv':
      parser = d3.csvParse
      break
    default:
      break
  }
  if (parser === undefined) {
    devOnlyLog('ERROR: getDsvData - unknown file extension')
    return undefined
  }
  const response = await axios.get(url)
  return parser(response.data)
}

export default {
  getDsvData
}



// WEBPACK FOOTER //
// ./src/api/index.js